import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  checkIsInFixedDaysOff,
  checkOutSideDateAndTime,
  getTimeSlot,
  isAnyShift,
} from "helpers/utils";
import { useListHolidayWithTime } from "hooks/holiday/useHoliday";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { SingleDatePicker } from "react-dates";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import * as yup from "yup";

import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import FormHubDeliverySelect from "components/Common/Form/FormHubDeliverySelect";
import FormInput from "components/Common/Form/FormInput";
import FormRadio from "components/Common/Form/FormRadio";
import FormSelect from "components/Common/Form/FormSelect";
import { ROLE_APP, USER_TYPE } from "constants/actionAccess";
import {
  OPTION_TRANSFER_ORDER_TYPE,
  SHIPPING_TYPE,
  TIME_SLOT_TYPE,
  TRANSFER_ORDER_TYPE,
} from "constants/order";
import {
  useDetailOrderHistory,
  useDetailTransferOrder,
  useListChildOrders,
  useMyHubsList,
  useOrderStatus,
  useTimeSlots,
} from "hooks";
import { useListHubContact } from "hooks/hub-delivery/useHubDelivery";
import jwt_decode from "jwt-decode";
import { MODE_DETAIL } from "pages/AllocateRunners/utils";
import OrderDetailHistory from "pages/Orders/OrderDetail/OrderDetailHistory/OrderDetailHistory";
import { orderStatusMode } from "pages/Orders/utils";
import { useRef } from "react";
import { MetaTags } from "react-meta-tags";
import { Link, useLocation, useParams } from "react-router-dom";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import TransferOrderAttachment from "./TransferOrderAttachment";
import TransferOrderChild from "./TransferOrderChild";
import "./TransferOrderForm.scss";
import { getPhoneValidation } from "constants/validate";

const convertObjectToArray = object => {
  const objectValue = object && Object.keys(object);
  return objectValue.map(item => ({ label: object?.[item], value: item }));
};

const TransferOrderForm = props => {
  const orderChildRef = useRef(null);
  const location = useLocation();

  const pageParams = useParams();
  const orderId = useMemo(() => {
    return pageParams?.orderDetailId || null;
  }, [pageParams]);

  const { t } = useTranslation(["order"]);
  const {
    handleCreateOrder,
    handleCancel,
    isLoadingSubmit,
    isHCMOrder,
    is_copy,
    handleCopyOrderMutate,
    isLoadingCopyOrder,
  } = props;

  const [isLogAdmin, setIsLogAdmin] = useState(false);
  const [isHubAdmin, setIsHubAdmin] = useState(false);
  const [fixedDaysOffHub, setFixDaysOffHub] = useState(undefined);

  const USE_TIME_SLOT_RULE = true;

  const initDefaultValues = {
    mode: MODE_DETAIL.VIEW,
    isTransferOrder: true,
    allowAddChild: false,
    allowRemoveChild: false,
    allowEdit: false,
    transferOrderType: OPTION_TRANSFER_ORDER_TYPE?.[0],
    orderId: "",
    orderStatusLabel: "",
    orderCostLabel: "",
    orderCheckerDate: "",
    idHubSend: "",
    levelHubSend: "",
    nameHubSend: "",
    hubReceive: "",
    addressHubReceive: "",
    wardNameHubReceive: "",
    districtNameHubReceive: "",
    provinceNameHubReceive: "",
    districtNameNewHubReceive: "",
    provinceNameNewHubReceive: "",
    contactNameHubReceive: "",
    contactPhone1HubReceive: "",
    contactPhone2HubReceive: "",

    deliveryHubReceive: null,
    busHubReceive: null,

    action_date: "",
    timeslot_id: null,

    childOrders: [],
    childOrdersSearchToAdd: [],
  };
  // START timeSlot
  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: { "filter[hub_id]": undefined, "filter[type][in]": [] },
    run: false,
    enabled: false,
    key: "time-slot-transfer-order",
  });

  const { data: timeSlots, refetch: refetchTimeSlots } =
    useTimeSlots(timeSlotsParams);

  useEffect(() => {
    if (timeSlotsParams && timeSlotsParams?.run) {
      refetchTimeSlots();
    }
  }, [timeSlotsParams]);

  const ruleTransferOrder = {
    allowAddChild: yup.bool(),
    allowRemoveChild: yup.bool(),

    allowEdit: yup.bool(),
    transferOrderType: yup.object().required(
      t("form.validate.required", {
        title: t("form.transferOrder.type"),
      })
    ),
    orderId: yup.string().nullable(),
    idHubSend: yup.string().nullable(),
    levelHubSend: yup.string().required(
      t("form.validate.required", {
        title: t("form.transferOrder.levelHub"),
      })
    ),
    nameHubSend: yup.string().required(
      t("form.validate.required", {
        title: t("form.transferOrder.nameHub"),
      })
    ),
    hubReceive: yup
      .object()
      .nullable()
      .required(
        t("form.validate.required", {
          title: t("form.transferOrder.nameHub"),
        })
      ),

    addressHubReceive: yup.string().nullable(),
    wardNameHubReceive: yup.string().nullable(),
    districtNameHubReceive: yup.string().nullable(),
    provinceNameHubReceive: yup.string().nullable(),
    districtNameNewHubReceive: yup.string().nullable(),
    provinceNameNewHubReceive: yup.string().nullable(),
    contactNameHubReceive: yup.string().nullable(),
    contactPhone1HubReceive: yup
      .string()
      .nullable()
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    contactPhone2HubReceive: yup
      .string()
      .nullable()
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    deliveryHubReceive: yup
      .object()
      .nullable()
      .required(
        t("form.validate.required", {
          title: t("form.transferOrder.deliveryHub"),
        })
      ),
    busHubReceive: yup
      .object()
      .nullable()
      .required(
        t("form.validate.required", {
          title: t("form.transferOrder.busHub"),
        })
      ),

    action_date: yup
      .string()
      .nullable()
      .required(t("form.validate.required", { title: t("form.action_date") })),
    timeslot_id: yup
      .object()
      .required(t("form.validate.select", { title: "Giờ hẹn" }))
      .nullable(),
    childOrders: yup
      .array()
      .min(
        1,
        t("form.validate.select", {
          title: "Đơn con",
        })
      )
      .nullable(),
  };
  // END timeSlot
  // const isAllowCreate = isMyOrder
  //   ? CheckActionAccess(actionAccess.GLOG_FUNCTION_MY_ORDER_ADD)
  //   : CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ADD);

  const schema = yup.object().shape(ruleTransferOrder);

  const { refetch: fetchOrderStatusList, data: orderStatusList } =
    useOrderStatus();

  const timeSlotMenuDefault = useMemo(() => {
    return (
      timeSlots?.items?.map(item => {
        return { label: item?.name, value: item };
      }) || []
    );
  }, [timeSlots?.items]);
  // time-slot menu
  const [timeSlotMenu, setTimeSlotMenu] = useState();

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ timeSlotMenuDefault:", timeSlotMenuDefault);
    setTimeSlotMenu(timeSlotMenuDefault);
  }, [timeSlots?.items]);

  const orderForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    watch,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = orderForm;

  const {
    mode,
    isTransferOrder,
    idHubSend,
    deliveryHubReceive,
    transferOrderType,
    hubReceive,
    allowEdit,
    allowAddChild,
    allowRemoveChild,
  } = watch();

  const { refetch: refetchDetailOrder, data: orderDetailData } =
    useDetailTransferOrder({
      orderId: orderId,
    });

  const [orderChildParams, setOrderChildParams] = useState({
    sizePerPage: 10,
    page: -1,
    sort: "-maker_date",
    columnFilter: {
      expand: "imagePath",
    },
    keywords: "",
    run: false,
    parent_id: null,
  });

  const onChildListSuccess = response => {
    const data = response?.items || [];
    console.log("🚀 ~ onChildListSuccess ~ data:", data);
    orderChildRef?.current?.setChildrenList(
      data?.map(o => {
        return {
          id: o?.id,
          checker_date: o?.checker_date,
          maker_date: o?.maker_date,
          ref_code: o?.ref_code,
          imagePath: o?.imagePath,
          order_code: o?.order_code,
          status: o?.status,
          type: o?.type,
          transport_name: o?.transport_name,

          sender_name: o?.sender_name,
          sender_contact_phone: o?.sender_contact_phone,
          sender_full_address: o?.sender_full_address,

          reciever_name: o?.reciever_name,
          reciever_contact_phone: o?.reciever_contact_phone,
          reciever_full_address: o?.reciever_full_address,
        };
      })
    );
  };

  const { isFetching: isLoadingChildListOrder, refetch: refecthListChild } =
    useListChildOrders(
      {
        params: orderChildParams,
        queryKey: "child-transfer-order",
      },
      onChildListSuccess
    );

  useEffect(() => {
    if (orderChildParams && orderChildParams?.run) {
      refecthListChild();
    }
  }, [orderChildParams]);

  // order detail history
  const {
    refetch: refetchOrderDetailHistory,
    data: history,
    isLoading: isHistoryLoading,
  } = useDetailOrderHistory({
    orderId: orderId,
  });
  useEffect(() => {
    if (orderId) {
      setValue("orderId", orderId);
      refetchDetailOrder();
      setOrderChildParams(prev => {
        return {
          ...prev,
          parent_id: orderId,
          run: true,
        };
      });
      refetchOrderDetailHistory(orderId);
      if (allowEdit) {
        setValue("mode", MODE_DETAIL.UPDATE);
      } else {
        setValue("allowAddChild", false);
        setValue("allowRemoveChild", false);
        setValue("mode", MODE_DETAIL.VIEW);
      }
    } else {
      setValue("allowAddChild", true);
      setValue("allowRemoveChild", true);
      setValue("mode", MODE_DETAIL.CREATE);
    }
  }, [orderId, allowEdit]);
  //

  // Tìm ngày nghỉ của HUB
  useEffect(() => {
    if (hubReceive) {
      setHolidaysParams(prev => {
        return {
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[hub_id]": hubReceive?.value,
          },
          run: true,
        };
      });
    }
  }, [hubReceive]);

  const [focusedInput, setFocusedInput] = useState(false);
  const [actionDate, setActionDate] = useState();

  useEffect(() => {
    if (!!actionDate && !!timeSlots) {
      const timeSlot = getTimeSlot({
        timeSlotOptions: timeSlotMenuDefault,
        date: actionDate,
        holidays: holidays?.items,
        isGrab: false,
        useTimeSlotRule: USE_TIME_SLOT_RULE,
        isHCMOrder: isHCMOrder,
      });
      console.log("🚀 ~ useEffect ~ setTimeSlotMenu:", timeSlot);
      setTimeSlotMenu(timeSlot);
      if (!getValues("timeslot_id") && !isHCMOrder) {
        const timeSlotDefault = timeSlots?.items?.find(time =>
          time.name.includes("Cả ngày")
        );
        if (timeSlotDefault) {
          setValue("timeslot_id", {
            label: timeSlotDefault.name,
            value: timeSlotDefault,
          });
        }
      }
    }
  }, [actionDate, timeSlots]);

  const onSetDaySize = () => {
    if (window.matchMedia("(max-width: 369px)").matches) {
      return 22;
    }
    if (window.matchMedia("(max-width: 450px)").matches) {
      return 24;
    }
    return undefined;
  };

  const onSubmit = () => {
    const data = getValues();
    console.log("🚀 ~ onSubmit ~ data:", data);
    const {
      transferOrderType,
      deliveryHubReceive,
      busHubReceive,
      timeslot_id,
      childOrders,
      childOrdersSearchToAdd,
      action_date,
      idHubSend,
      hubReceive,
    } = data;
    console.log("🚀 ~ onSubmit ~ childOrders:", childOrders);

    const actionDate = action_date
      ? moment(action_date).format("YYYY-MM-DD")
      : null;
    const shippingType = deliveryHubReceive?.shippingType;
    const finalData = {
      type: transferOrderType?.value,
      transport_id: deliveryHubReceive?.value,
      // transport_id: shippingType !== 3 ? deliveryHubReceive?.value : null,
      bus_id: shippingType === 3 ? busHubReceive?.value : null,
      shipping_type: shippingType,
      action_date: actionDate,
      timeslot_id: timeslot_id?.value?.id,
      sub_order_codes: childOrders?.map(c => c.order_code),
      from_hub: idHubSend,
      to_hub: hubReceive?.value,
    };
    console.log("🚀 ~ onSubmit ~ finalData:", finalData);
    handleCreateOrder?.(finalData);
  };

  const [holidaysParams, setHolidaysParams] = useState({
    sizePerPage: 10,
    page: -1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  });

  const {
    data: holidays,
    isFetching: isLoadingHolidayList,
    refetch: fetchHolidays,
  } = useListHolidayWithTime({
    params: holidaysParams,
    useToDisalbeCalendar: true,
    queryKey: "holiday-list-transfer-order-with-time",
  });

  useEffect(() => {
    if (holidaysParams && holidaysParams?.run) {
      fetchHolidays();
    }
  }, [holidaysParams]);

  useEffect(() => {
    console.log("🚀 ~ file: OrdersForm.js:1013 ~ useEffect ~ errors:", errors);
  }, [errors]);

  const { data: myHubs, refetch: refetchMyHubs } = useMyHubsList(
    {
      queryKey: `my-hub-transfer-order`,
      enabled: true,
    },
    res => {}
  );

  const [hubContactParams, setHubContactParams] = useState({
    sizePerPage: 1000,
    page: 1,
    sort: "-maker_date",
    columnFilter: {
      "filter[record_status]": "O",
      "filter[is_default]": 1,
    },
    keywords: "",
    fields: "",
    run: false,
  });

  const { data: dataHubContact, refetch: refetchHubContact } =
    useListHubContact({
      key: `hub-contact-transfer-order`,
      enabled: false,
      params: hubContactParams,
    });

  const setHubSendInfo = hubSendData => {
    if (!hubSendData) {
      return;
    }
    console.log("🚀 ~ setHubSendInfo ~ hubSendData:", hubSendData);
    const isCenter = hubSendData?.is_center ? true : false;
    setValue("idHubSend", hubSendData?.id);
    setValue("levelHubSend", isCenter ? "Center" : "Hub");
    setValue("nameHubSend", hubSendData?.name);
  };

  const setHubReceiveInfo = (hubReceiveData, isFilterHubContact = true) => {
    if (!hubReceiveData) {
      return;
    }
    console.log("🚀 ~ setHubReceiveInfo ~ hubReceiveData:", hubReceiveData);

    setValue("hubReceive", {
      value: hubReceiveData?.id,
      label: hubReceiveData?.name,
    });
    setValue("addressHubReceive", hubReceiveData?.address);

    // Kiểm tra xem có phải địa chỉ mới (2 cấp) hay không
    const isNewAddress = hubReceiveData?.is_new_address === "N";

    if (isNewAddress) {
      // Địa chỉ 2 cấp: không có ward, dùng district_name_new và province_name_new
      setValue("wardNameHubReceive", null);
      setValue(
        "districtNameHubReceive",
        hubReceiveData?.district_name_new || hubReceiveData?.district_name
      );
      setValue(
        "provinceNameHubReceive",
        hubReceiveData?.province_name_new || hubReceiveData?.province_name
      );
      // Clear các field không dùng
      setValue("districtNameNewHubReceive", null);
      setValue("provinceNameNewHubReceive", null);
    } else {
      // Địa chỉ 3 cấp: có đầy đủ ward/district/province
      setValue("wardNameHubReceive", hubReceiveData?.ward_name);
      setValue("districtNameHubReceive", hubReceiveData?.district_name);
      setValue("provinceNameHubReceive", hubReceiveData?.province_name);
      setValue("districtNameNewHubReceive", null);
      setValue("provinceNameNewHubReceive", null);
    }

    setFixDaysOffHub(hubReceiveData?.fixed_days_off);

    if (isFilterHubContact) {
      setHubContactParams(prev => {
        return {
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            "filter[hub_id]": hubReceiveData?.id,
          },
          run: true,
        };
      });
    } else {
      setValue("contactNameHubReceive", hubReceiveData?.contact_name);
      setValue("contactPhone1HubReceive", hubReceiveData?.contact_phone1);
      setValue("contactPhone2HubReceive", hubReceiveData?.contact_phone2);
    }
  };

  const setHubReceiveContactInfo = hubContact => {
    setValue("contactNameHubReceive", hubContact?.name);
    setValue("contactPhone1HubReceive", hubContact?.phone1);
    setValue("contactPhone2HubReceive", hubContact?.phone2);
  };

  useEffect(() => {
    if (hubContactParams && hubContactParams?.run) {
      refetchHubContact();
    }
  }, [hubContactParams]);

  // Set thông tin người liên hệ của HUB
  useEffect(() => {
    if (dataHubContact) {
      const data = dataHubContact?.items?.[0];
      if (data) {
        setHubReceiveContactInfo(data);
      }
    }
  }, [dataHubContact]);

  // Set thông tin nhà xe của dvvc
  useEffect(() => {
    if (deliveryHubReceive) {
      const { transport, busData } = deliveryHubReceive;
      if (!orderDetailData || is_copy) {
        setValue("busHubReceive", busData);
      }
      if (hubReceive) {
        let arrayTimeSlotType = [];
        if (transport?.shipping_type === SHIPPING_TYPE.RUNNER) {
          arrayTimeSlotType = [
            TIME_SLOT_TYPE.COORDINATE,
            TIME_SLOT_TYPE.RUNNER,
          ];
        } else if (transport?.shipping_type === SHIPPING_TYPE.NHAXE) {
          arrayTimeSlotType = [TIME_SLOT_TYPE.BUS];
        } else {
          arrayTimeSlotType = [TIME_SLOT_TYPE.DVVC];
        }
        setTimeSlotsParams(prev => {
          return {
            ...prev,
            params: {
              "filter[hub_id]":
                transferOrderType.value === TRANSFER_ORDER_TYPE.RECEIVE
                  ? idHubSend
                  : hubReceive?.value,
              "filter[type][in]": arrayTimeSlotType,
            },
            run: true,
          };
        });
      }
    }
  }, [deliveryHubReceive, hubReceive, orderDetailData]);

  const setInforOrderFromDetail = ({
    status,
    cost_value,
    cost,
    checker_date,
    action_date,
    timeslot_id,
    from_hub,
    to_hub,
    type,
    listOrders,
    allowEdit,
    is_copy,
    busHubReceive,
  }) => {
    const normalizedCost = Math.trunc(Number(cost_value ?? cost ?? 0));
    const orderCostDisplay = Number.isNaN(normalizedCost)
      ? ""
      : `${new Intl.NumberFormat("en-US").format(normalizedCost)} đ`;

    setValue("allowEdit", allowEdit || false);
    setValue(
      "transferOrderType",
      OPTION_TRANSFER_ORDER_TYPE?.find(t => t.value === type)
    );
    setValue(
      "orderStatusLabel",
      orderStatusList.find(x => String(status) === x?.value)?.label
    );
    setValue(
      "orderCheckerDate",
      moment(new Date(checker_date * 1000)).format("DD/MM/YYYY HH:mm:ss")
    );
    setValue("orderCostLabel", orderCostDisplay);
    setHubSendInfo(from_hub);
    setHubReceiveInfo(to_hub, false);
    if (!is_copy) {
      setValue("busHubReceive", busHubReceive);
      setActionDate(moment(action_date, "YYYY-MM-DD HH:mm:ss"));
      setValue("action_date", moment(action_date, "YYYY-MM-DD HH:mm:ss"));
    }
  };

  const setInforOrderFromScan = ({
    myHubInfo,
    from_hub,
    to_hub,
    listOrders,
    type,
    allowEdit,
  }) => {
    setValue("allowEdit", allowEdit || f);
    if (type) {
      setValue(
        "transferOrderType",
        OPTION_TRANSFER_ORDER_TYPE?.find(t => t.value === type)
      );
    }
    const { childs_hub, hub, parent_hub, user } = myHubInfo;
    if (!hub) {
      return;
    }
    const transferOrderTypeCheck = type || transferOrderType?.value;
    const { user_type } = user;
    const childHubSelected =
      childs_hub?.find(h => h?.id === from_hub?.id || h?.id === to_hub?.id) ||
      null;
    if (listOrders?.length > 0) {
      orderChildRef?.current?.setChildrenList(
        listOrders?.map(o => {
          return {
            id: o?.id,
            checker_date: o?.checker_date,
            order_code: o?.order_code,
            status: o?.status,
            type: o?.type,
            maker_date: o?.maker_date,
            ref_code: o?.ref_code,
            imagePath: o?.imagePath,
            transport_name: o?.transport_name,

            sender_name: o?.sender_name,
            sender_contact_phone: o?.sender_contact_phone,
            sender_full_address: o?.sender_full_address,

            reciever_name: o?.reciever_name,
            reciever_contact_phone: o?.reciever_contact_phone,
            reciever_full_address: o?.reciever_full_address,
          };
        })
      );
    }
    // Đơn nhận mẫu
    if (transferOrderTypeCheck === TRANSFER_ORDER_TYPE?.RECEIVE) {
      // HUB ADMIN
      if (user_type === USER_TYPE.HUB_ADMIN) {
        // From Hub (HUB quản lý)
        setHubSendInfo(hub);
        // ToCenter (lấy từ parentHub)
        setHubReceiveInfo(parent_hub);
      } else if (user_type === USER_TYPE.LOG_AMDIN) {
        // LOG ADMIN
        // From Hub (Select từ list Hub của center)
        setHubSendInfo(childHubSelected);
        // To Center (Center quản lý)
        setHubReceiveInfo(to_hub);
      }
    }
    // Đơn trả kết quả
    if (transferOrderTypeCheck === TRANSFER_ORDER_TYPE?.RETURN) {
      // HUB ADMIN
      if (user_type === USER_TYPE.HUB_ADMIN) {
        // From Center (lấy từ parentHub)
        setHubSendInfo(parent_hub);
        // To Hub (HUB quản lý)
        setHubReceiveInfo(hub);
      } else if (user_type === USER_TYPE.LOG_AMDIN) {
        // LOG ADMIN
        // From Center (Center quản lý)
        setHubSendInfo(hub);
        // To Hub (Select từ list Hub của center)
        setHubReceiveInfo(to_hub);
      }
    }
  };

  // Set thông tin HUB
  useEffect(() => {
    if (myHubs && location?.state) {
      const { from_hub, to_hub, listOrders, type, allowEdit } = location?.state;
      if (!orderId) {
        console.log("🚀 ~ useEffect ~ setInforOrderFromScan:");
        // Từ màn hình quét kiện, quét nhận kết quả
        setInforOrderFromScan({
          myHubInfo: myHubs,
          from_hub,
          to_hub,
          listOrders,
          type,
          allowEdit: true,
        });
      }
    }
  }, [myHubs, location.state, orderId]);

  // Check permission for action to order child
  const checkPermissionsForOrderChild = ({ type, status }) => {
    if (isLogAdmin) {
      // Đơn nhận mẫu:
      if (type === TRANSFER_ORDER_TYPE.RECEIVE) {
        // Logs admin Thêm và xóa đơn con ở tất cả trạng thái
        setValue("allowAddChild", true);
        setValue("allowRemoveChild", true);
      }
      // Đơn trả kết quả:
      if (type === TRANSFER_ORDER_TYPE.RETURN) {
        // Logs admin Thêm và xóa đơn con ở tất cả trạng thái trừ "Hoàn tất"
        if (status !== orderStatusMode.COMPLETED) {
          setValue("allowAddChild", true);
          setValue("allowRemoveChild", true);
        }
      }
    }
    if (isHubAdmin) {
      // Đơn nhận mẫu:
      if (type === TRANSFER_ORDER_TYPE.RECEIVE) {
        //  HubAdmin Thêm và xóa đơn con ở trạng thái "Tạo đơn" ,"Đã điều phối"
        if (
          [orderStatusMode.COORDINATED, orderStatusMode.MAKE].includes(status)
        ) {
          setValue("allowAddChild", true);
          setValue("allowRemoveChild", true);
        }
      }
    }
  };

  // Set thông tin HUB
  useEffect(() => {
    if (orderDetailData) {
      console.log("🚀 ~ TransferOrderForm ~ orderDetailData:", orderDetailData);

      const allowEdit = location?.state?.allowEdit;
      // Xem chi tiết, cập nhật đơn trung chuyển
      const {
        from_hub_is_center,
        from_hub_name,
        to_hub_name,
        from_hub,
        to_hub,
        reciever_address,
        reciever_ward_name,
        reciever_district_name,
        reciever_province_name,
        reciever_district_name_new,
        reciever_province_name_new,
        reciever_contact_name,
        reciever_contact_phone,
        reciever_contact_phone2,

        action_date,
        timeslot_id,
        status,
        type,
        transport_name,
        transport_id,
      } = orderDetailData;
      setValue("isTransferOrder", true);
      checkPermissionsForOrderChild({ status: status, type: type });
      setInforOrderFromDetail({
        status: orderDetailData?.status,
        cost_value: orderDetailData?.cost_value,
        cost: orderDetailData?.cost,
        checker_date: orderDetailData?.checker_date,
        action_date: orderDetailData?.action_date,
        timeslot_id: orderDetailData?.timeslot_id,
        from_hub: {
          id: from_hub,
          is_center: from_hub_is_center,
          name: from_hub_name,
        },
        to_hub: {
          id: to_hub,
          name: to_hub_name,
          address: reciever_address,
          ward_name: reciever_ward_name,
          district_name_new: reciever_district_name_new,
          district_name: reciever_district_name,
          province_name: reciever_province_name,
          province_name_new: reciever_province_name_new,
          contact_name: reciever_contact_name,
          contact_phone1: reciever_contact_phone,
          contact_phone2: reciever_contact_phone2,
        },
        type: orderDetailData?.type,
        listOrders: [],
        allowEdit: allowEdit || false,
        is_copy,
        busHubReceive: {
          label: transport_name,
          value: transport_id,
        },
      });
    }
  }, [orderDetailData, isLogAdmin, isHubAdmin, orderStatusList]);

  // Set thông tin giờ hẹn từ detail
  useEffect(() => {
    if (orderDetailData && timeSlotMenuDefault?.length > 0) {
      const timeSlotDefault = timeSlotMenuDefault.find(
        time => time?.value?.id === orderDetailData?.timeslot_id
      );
      setValue("timeslot_id", timeSlotDefault);
    }
  }, [orderDetailData, timeSlotMenuDefault]);

  useEffect(() => {
    fetchOrderStatusList();

    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const listRole = info["auth"].split(",");
    setIsHubAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_HUB_ADMIN))
        ? true
        : false || false
    );
    setIsLogAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_LOG_ADMIN))
        ? true
        : false || false
    );
  }, []);

  const checkIsDisableDate = (
    date,
    listHolidays,
    fixedDaysOff,
    timeSlotMenu,
    isHCMOrder_
  ) => {
    return (
      !isAnyShift({
        timeSlotOptions: timeSlotMenu,
        date: date,
        holidays: listHolidays,
        isGrab: false,
        useTimeSlotRule: USE_TIME_SLOT_RULE,
        isHCMOrder: isHCMOrder_,
      }) ||
      checkOutSideDateAndTime(date, listHolidays) ||
      checkIsInFixedDaysOff(fixedDaysOff, date)
    );
  };

  const [dateFind, setDateFind] = useState(undefined);

  useEffect(() => {
    if ((!orderId && fixedDaysOffHub) || is_copy) {
      let isFound = false;
      let index = 1;
      while (!isFound && index < 30) {
        let checkday = moment().add(index, "days");

        if (moment(checkday).isAfter(moment(), "day")) {
          if (
            !checkIsDisableDate(
              checkday,
              holidays?.items,
              fixedDaysOffHub,
              timeSlotMenuDefault,
              isHCMOrder
            )
          ) {
            isFound = true;
            setDateFind(checkday);
          }
        }
        index++;
      }
    }
  }, [
    fixedDaysOffHub,
    holidays,
    orderId,
    timeSlotMenuDefault,
    isHCMOrder,
    is_copy,
  ]);

  useEffect(() => {
    if (!orderId || is_copy) {
      setValue("action_date", dateFind);
      setActionDate(dateFind);
    }
  }, [dateFind, orderId]);

  const onScanSearch = () => {
    let path = "";
    if (transferOrderType.value === TRANSFER_ORDER_TYPE.RECEIVE) {
      path = "scan-barcode";
    } else {
      path = "scan-send-barcode";
    }
    window.open(`/${path}?search=${orderDetailData?.order_code}`, "_blank");
  };

  const handleCopyOrder = () => {
    trigger(["action_date", "timeslot_id"]).then(isValid => {
      if (isValid) {
        const { timeslot_id, action_date, busHubReceive } = getValues();
        const actionDate = action_date
          ? moment(action_date).format("YYYY-MM-DD")
          : null;
        const timeslotId = timeslot_id?.value?.id;
        const copyData = {
          type: orderDetailData.type,
          transport_id: orderDetailData.transport_id
            ? busHubReceive.value
            : undefined,
          bus_id: orderDetailData.bus_id || undefined,
          shipping_type: orderDetailData.shipping_type,
          action_date: actionDate,
          timeslot_id: timeslotId,
          sub_order_codes: orderDetailData.child_codes,
          from_hub: orderDetailData.from_hub,
          to_hub: orderDetailData.to_hub,
        };
        handleCopyOrderMutate?.(orderId, copyData);
      }
    });
  };

  return (
    <>
      <MetaTags>
        <title>{t(`mode.${is_copy ? "copy" : mode}`)} đơn trung chuyển</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={`${t(`mode.${is_copy ? "copy" : mode}`)} đơn trung chuyển ${
            orderDetailData?.order_code ? orderDetailData?.order_code : ""
          }`}
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.list"), link: "/manage-transfer-orders" },
            { name: t("title.create") },
          ]}
        />
      </div>
      {!isTransferOrder ? (
        <Row>
          <div
            className="d-flex gap-2 align-items-center text-warning"
            style={{ fontSize: "30px", fontStyle: "italic" }}
          >
            <i className="bx bx-error" />
            <div>Không phải đơn trung chuyển</div>
          </div>
        </Row>
      ) : (
        <Card
          body
          className="transfer-order-form"
          style={{ marginBottom: "150px" }}
        >
          {Boolean(orderDetailData?.is_reminder_order || 0) && (
            <Alert color="primary">
              Đơn được tạo tự động.
              <Link
                className="alert-link mx-2"
                to={`/manage-orders/${orderDetailData?.order_source_id}`}
                rel="noreferrer"
                target="_blank"
              >
                Xem đơn gốc
              </Link>
            </Alert>
          )}
          <Form>
            <Row>
              <Col>
                <FormRadio
                  isLabel={false}
                  isDisabled
                  mainForm={orderForm}
                  fieldName="transferOrderType"
                  t={t}
                  tile={t("placeholder.select", {
                    title: t("form.transferOrder.type"),
                  })}
                  dataList={OPTION_TRANSFER_ORDER_TYPE}
                />
              </Col>
              <Col className="text-end">
                <Button color="warning" onClick={onScanSearch}>
                  Quét tìm kiếm
                </Button>
              </Col>
            </Row>
            {orderId && (
              <Row className="mt-3 ">
                <Col xs="4">
                  <Row>
                    <Col xs="4">
                      <FormInput
                        mainForm={orderForm}
                        isDisabled={true}
                        fieldName="orderStatusLabel"
                        type="text"
                        t={t}
                        title={"Trạng thái"}
                      />
                    </Col>
                    <Col xs="4">
                      <FormInput
                        mainForm={orderForm}
                        isDisabled={true}
                        fieldName="orderCostLabel"
                        type="text"
                        t={t}
                        title={"Chi phí"}
                      />
                    </Col>
                    <Col xs="4">
                      <FormInput
                        mainForm={orderForm}
                        isDisabled={true}
                        fieldName="orderCheckerDate"
                        type="text"
                        t={t}
                        title={"Thời gian cập nhật gần nhất"}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}

            <Row className="mt-3 info-transfer-order">
              <Col xs="4">
                <Row xs={1} md={2}>
                  <h4>{t("form.transferOrder.senderInformation")} </h4>
                </Row>
                <Row>
                  <Col xs="4">
                    <FormInput
                      mainForm={orderForm}
                      isDisabled={true}
                      fieldName="levelHubSend"
                      type="text"
                      t={t}
                      title={t("form.transferOrder.levelHub")}
                      placeholder={t("placeholder.select", {
                        title: t("form.transferOrder.levelHub"),
                      })}
                    />
                  </Col>
                  <Col xs="8">
                    <FormInput
                      mainForm={orderForm}
                      isDisabled={true}
                      fieldName="nameHubSend"
                      type="text"
                      t={t}
                      title={t("form.transferOrder.nameHub")}
                      placeholder={t("placeholder.select", {
                        title: t("form.transferOrder.nameHub"),
                      })}
                    />
                  </Col>
                </Row>
                {transferOrderType?.value === TRANSFER_ORDER_TYPE.RECEIVE && (
                  <Row className="transport-bus">
                    <Col xs="4">
                      <FormHubDeliverySelect
                        isDisabled
                        mainForm={orderForm}
                        fieldName="deliveryHubReceive"
                        t={t}
                        title={t("form.transferOrder.deliveryHub")}
                        paramsColumnFilter={
                          idHubSend
                            ? {
                                "filter[hub_id]": idHubSend,
                                "filter[order_type]": transferOrderType?.value,
                              }
                            : null
                        }
                      />
                    </Col>
                    <Col xs="8">
                      <FormSelect
                        isDisabled
                        mainForm={orderForm}
                        fieldName="busHubReceive"
                        t={t}
                        title={t("form.transferOrder.busHub")}
                        placeholder={t("placeholder.select", {
                          title: t("form.transferOrder.busHub"),
                        })}
                        dataList={[]}
                      />
                    </Col>
                  </Row>
                )}
              </Col>
              <Col xs="1">
                <div
                  className="d-flex justify-content-center"
                  style={{ marginTop: "-13px" }}
                >
                  <i
                    style={{
                      fontSize: "40px",
                    }}
                    className={"text-info mdi mdi-ray-start-arrow"}
                  />
                </div>
              </Col>
              <Col xs="7">
                <Row xs={1} md={2}>
                  <h4>{t("form.transferOrder.recipientInformation")} </h4>
                </Row>
                <Row xs={1} md={1}>
                  <FormSelect
                    // isRequired
                    isDisabled
                    dataList={[]}
                    mainForm={orderForm}
                    fieldName="hubReceive"
                    t={t}
                    title={t("form.transferOrder.nameHub")}
                  />
                  {/* {transferOrderType?.value === TRANSFER_ORDER_TYPE.RETURN && (
                  // Hub
                  <FormHubSelect
                    isMyHubOnly
                    // hubIdDefault={busDetail?.hub_id}
                    isRequired
                    mainForm={orderForm}
                    fieldName="hubReceive"
                    t={t}
                    title={t("form.transferOrder.nameHub")}
                    // isDisabled={controlFields.disabled?.hub_id}
                  />
                )} */}
                </Row>
                <Row xs={1} md={4}>
                  <FormInput
                    mainForm={orderForm}
                    isDisabled={true}
                    fieldName="addressHubReceive"
                    type="text"
                    t={t}
                    title={t("form.transferOrder.addressHub")}
                    placeholder={t("form.transferOrder.addressHub")}
                  />

                  {watch("wardNameHubReceive") && (
                    <FormInput
                      mainForm={orderForm}
                      isDisabled={true}
                      fieldName="wardNameHubReceive"
                      type="text"
                      t={t}
                      title={t("form.transferOrder.wardNameHub")}
                      placeholder={t("form.transferOrder.wardNameHub")}
                    />
                  )}

                  <FormInput
                    mainForm={orderForm}
                    isDisabled={true}
                    fieldName="districtNameHubReceive"
                    type="text"
                    t={t}
                    title={t("form.transferOrder.districtNameHub")}
                    placeholder={t("form.transferOrder.districtNameHub")}
                  />

                  <FormInput
                    mainForm={orderForm}
                    isDisabled={true}
                    fieldName="provinceNameHubReceive"
                    type="text"
                    t={t}
                    title={t("form.transferOrder.provinceNameHub")}
                    placeholder={t("form.transferOrder.provinceNameHub")}
                  />
                </Row>
                <Row xs={1} md={4}>
                  <FormInput
                    mainForm={orderForm}
                    isDisabled={true}
                    fieldName="contactNameHubReceive"
                    type="text"
                    t={t}
                    title={t("form.transferOrder.contactNameHub")}
                    placeholder={t("form.transferOrder.contactNameHub")}
                  />
                  <FormInput
                    mainForm={orderForm}
                    isDisabled={true}
                    fieldName="contactPhone1HubReceive"
                    type="text"
                    t={t}
                    title={t("form.transferOrder.contactPhoneHub") + ` 1`}
                    placeholder={t("form.transferOrder.contactPhoneHub") + ` 1`}
                  />
                  <FormInput
                    mainForm={orderForm}
                    isDisabled={true}
                    fieldName="contactPhone2HubReceive"
                    type="text"
                    t={t}
                    title={t("form.transferOrder.contactPhoneHub") + ` 2`}
                    placeholder={t("form.transferOrder.contactPhoneHub") + " 2"}
                  />
                </Row>
                {transferOrderType?.value === TRANSFER_ORDER_TYPE.RETURN && (
                  <Row className="transport-bus">
                    <Col xs="3">
                      <FormHubDeliverySelect
                        // isDisabled={!allowEdit || orderDetailData}
                        isDisabled={true}
                        mainForm={orderForm}
                        fieldName="deliveryHubReceive"
                        t={t}
                        title={t("form.transferOrder.deliveryHub")}
                        paramsColumnFilter={
                          hubReceive
                            ? {
                                "filter[hub_id]": hubReceive?.value,
                                "filter[order_type]": transferOrderType?.value,
                              }
                            : null
                        }
                      />
                    </Col>
                    <Col xs="6">
                      <FormSelect
                        isDisabled
                        mainForm={orderForm}
                        fieldName="busHubReceive"
                        t={t}
                        title={t("form.transferOrder.busHub")}
                        placeholder={t("placeholder.select", {
                          title: t("form.transferOrder.busHub"),
                        })}
                        dataList={[]}
                      />
                    </Col>
                  </Row>
                )}

                <Label>
                  Thời gian hẹn <span className="text-danger">*</span>
                </Label>
                <Row className="action-date_time-slot">
                  <Col xs="3">
                    <FormGroup>
                      <div
                        className="d-flex align-items-center action_date_input"
                        style={{
                          backgroundColor:
                            !is_copy &&
                            (isLoadingHolidayList ||
                              !allowEdit ||
                              orderDetailData)
                              ? "#f4f5f4"
                              : "white",
                        }}
                      >
                        <span
                          style={{ paddingLeft: "12px" }}
                          className="prefix"
                        >
                          {t("form.action_date_label")}
                        </span>
                        <Controller
                          control={control}
                          name="action_date"
                          render={({ field }) => (
                            <SingleDatePicker
                              {...field}
                              date={actionDate}
                              onDateChange={date => {
                                setValue("action_date", date);
                                setActionDate(date);
                                setError("action_date");
                                setValue("timeslot_id", null);
                              }}
                              focused={focusedInput}
                              onFocusChange={({ focused }) =>
                                setFocusedInput(focused)
                              }
                              isOutsideRange={date =>
                                checkIsDisableDate(
                                  date,
                                  holidays?.items,
                                  fixedDaysOffHub,
                                  timeSlotMenuDefault,
                                  isHCMOrder
                                )
                              }
                              displayFormat="DD/MM/YYYY"
                              numberOfMonths={1}
                              small
                              placeholder=""
                              showDefaultInputIcon
                              inputIconPosition="after"
                              readOnly
                              daySize={onSetDaySize()}
                              disabled={
                                is_copy
                                  ? false
                                  : isLoadingHolidayList ||
                                    !allowEdit ||
                                    orderDetailData
                              }
                            />
                          )}
                        />
                      </div>
                      {errors.action_date && (
                        <MessageFormValidate
                          error={errors.action_date.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <Label htmlFor="orderHour" className="visually-hidden" />
                      <Controller
                        control={control}
                        name="timeslot_id"
                        render={({ field }) => (
                          <Select
                            {...field}
                            placeholder={t("placeholder.select", {
                              title: "Giờ hẹn",
                            })}
                            id="orderHour"
                            classNamePrefix="select2-selection"
                            isSearchable
                            options={timeSlotMenu}
                            isDisabled={
                              is_copy
                                ? false
                                : !getValues("action_date") ||
                                  !allowEdit ||
                                  orderDetailData
                            }
                          />
                        )}
                      />
                      {errors.timeslot_id && (
                        <MessageFormValidate
                          error={errors.timeslot_id.message}
                        />
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <TransferOrderAttachment orderId={orderId} />
            <Row>
              <TransferOrderChild
                ref={orderChildRef}
                transferOrderType={transferOrderType?.value}
                isShowBtnDeleteChild={
                  allowRemoveChild && mode !== MODE_DETAIL?.VIEW
                }
                isShowBtnAddChild={allowAddChild && mode !== MODE_DETAIL?.VIEW}
                mainForm={orderForm}
                isDeleteTemp={mode === MODE_DETAIL.CREATE}
                pathDetail={"manage-orders"}
                parent_id={orderId}
                fieldChildName={"childOrders"}
                fieldSearchOrderToAddName={"childOrdersSearchToAdd"}
                orderStatusList={orderStatusList}
                onSuccessRemoveChild={() => {
                  refecthListChild();
                }}
                onSuccessAddChild={() => {
                  refecthListChild();
                }}
                setOrderChildParams={setOrderChildParams}
                isShowSearch={true}
              />
            </Row>
            {orderId && !is_copy && (
              <Row>
                <OrderDetailHistory
                  data={history}
                  status={orderStatusList}
                  isLoading={isHistoryLoading}
                />
              </Row>
            )}
            {is_copy && (
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  disabled={isLoadingCopyOrder}
                  size="xs"
                  color="primary"
                  style={{ backgroundColor: "#3C64B1" }}
                  onClick={handleCopyOrder}
                >
                  {t("button.copy")}
                </Button>
              </div>
            )}
            {mode === MODE_DETAIL.CREATE && (
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  color="danger"
                  className="border-0"
                  size="xs"
                  onClick={() => handleCancel()}
                >
                  {t("button.cancel")}
                </Button>
                <Button
                  disabled={isLoadingSubmit}
                  size="xs"
                  color="primary"
                  style={{ backgroundColor: "#3C64B1" }}
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  {t("button.confirm")}
                </Button>
              </div>
            )}
            {!is_copy && mode !== MODE_DETAIL.CREATE && (
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  color="danger"
                  className="border-0"
                  size="xs"
                  onClick={() => handleCancel()}
                >
                  Trở về
                </Button>
              </div>
            )}
          </Form>
        </Card>
      )}
    </>
  );
};

TransferOrderForm.propTypes = {
  isHCMOrder: PropTypes.bool,
  handleCreateOrder: PropTypes.func,
  handleCancel: PropTypes.func,
  isLoadingSubmit: PropTypes.bool,
  is_copy: PropTypes.bool,
  isLoadingCopyOrder: PropTypes.bool,
  handleCopyOrderMutate: PropTypes.func,
};
export default TransferOrderForm;
